/* eslint-disable import/prefer-default-export */
import faqSchema from '@seo/schemas/faq';
import { generateBreadcrumbs } from './breadcrumbs';

export const genarateSchema = ({ faqs, predictorURL }) => {
  const graph = [generateBreadcrumbs({ predictorURL })];

  const faqSchemaEntry = faqSchema(faqs);
  if (faqSchemaEntry) graph.push(faqSchemaEntry);

  const schema = {
    '@context': 'https://schema.org/',
    '@graph': graph
  };

  return schema;
};
